module.exports = __webpack_public_path__ + "img/readingGroup.2b962cda.jpg";